import AnjunTableList from '@/components/anjun-tableList';
import { headerList, tableHeaderForm } from './tableHeadListData/index';
import EditCmp from './component/EditCmp/index.vue';
import TrackQuery from './component/trackQuery/trackQuery.vue';
import methods1 from './index.methods1.js';
import methods2 from './index.methods2.js';
export default {
  name: 'ServiceOroviderOrder',
  components: {
    AnjunTableList,
    EditCmp,
    TrackQuery
  },
  data() {
    return {
      TrackParam: {}, // 轨迹详情
      // 操作表头弹窗
      isoperationTable: false,
      tableHeaderForm: {
        tableHeaderList: tableHeaderForm
      },
      // 是否格式化成巴西时间
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      isTormat: false,
      timeValue: [],
      provideNameList: [],
      orderStatusList: [
        { id: 1, label: this.$t('navbar.waitGetNumber') },
        { id: 2, label: this.$t('navbar.getNumberSuccess') },
        { id: 3, label: this.$t('navbar.getNumbering') },
        { id: 4, label: this.$t('navbar.getNumberFail') }
      ],
      tableHeaderList: headerList,
      tableData: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          searchTimeType: '1',
          providerOrderStatus: '',
          searchNumberType: '1',
          providerId: '',
          customerId: '',
          searchNumberStr: '',
          merchantName: '',
          merchantCode: ''
        }
      },
      showQueryTrack: {
        visible: false,
        trackKey: new Date().getTime()
      },
      queryTrackParam: {},
      // 勾选表格数据
      selectionList: [],
      waybillDescription: {
        visible: false,
        ids: 0,
        isEdit: false // 能否修改，如果当前订单是 取号成功则不能编辑
      },
      // 切换表头列
      bindTableColumns: headerList,
      downloadArr: [],
      exportParam: {},
      customerList: [],
      waybillIds: [],
      routeIds: [],
      reDistruForm: {
        reProviderDialog: false, // 重新分配服务商
        providerId: ''
      },
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 6 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      senderInformationDialog: false,
      senderInformationList: [],
      senderInformationId: '', // 发件人信息id
      senderInformationIdObj: {}// 发件人对象
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '250px' : '130px'
      };
    },
    IsWidthTime() {
      return {
        width: this.isTormat ? '200px' : '150px'
      };
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getSearch();
  },
  mounted() {
    // 获取客户列表
    this.getCustomerList();
    this.getsenderInforma();
    this.getProviderList();
  },
  methods: { ...methods1, ...methods2 }
};
